module.exports = __webpack_public_path__ + "img/logoTrees.6cb519a5.png";